import React from 'react'

const NotFound = () => <h1>Ops! 404 not found</h1>

export default NotFound;